// extracted by css-extract-rspack-plugin
export default {"dataPicker":"ogNj5","databaseSelector":"fMN9R"};